<template>
  <v-touch class="week-day" v-on:press="showOccupation" v-on:panstart="showOccupation" v-on:pancancel="hideOccupation"
    v-on:panend="hideOccupation" v-on:pressup="hideOccupation">
    <div class="week-day-content" @mouseover="showOccupation" @mouseout="hideOccupation" @mouseleave="hideOccupation">
      <div class="week-day-number" @click='clickDay()'>{{ day.day }}</div>
      <div v-if="getCountNewStateByDay(day) > 0" class="week-day-newResa">{{ getCountNewStateByDay(day) }}</div>
      <el-popover placement="right" v-model="popover" trigger="click" popper-class="popup-delete black-inputs">
        <div class="popup-sc-date">{{ day.labelDay }} {{ day.day }} {{ day.labelMonth }}</div>
        <div v-if="!getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())">
          <div class="popup-sc" v-for='(ms, msKey) in getMainServicesForDay(day, true, true)' :key="msKey">
            <div class="popup-sc-sub" v-for='(s, sKey) in ms' :key="sKey">
              <el-row :gutter="0" v-if="s">
                <el-col>
                  <div class="popup-sc-sub_name">{{ s.name }}</div>
                </el-col>
                <el-col>
                  <span class="popup-sc-sub_name">Ouverture : </span>
                  <el-switch v-model="switchers[s.name]" active-color="#5daf8f" inactive-color="#e95d5d"
                    @change="selectSwitcherChange(s)">
                  </el-switch>
                </el-col>
                <el-col v-if="cashState(s.name)">
                  <div>Avec {{ cashState(s.name).type }} de {{ cashState(s.name).value }} €/couv. <button
                      v-if="!cashState(s.name).isOnService" @click="editCashInfos(day, s.name)">Modifier</button></div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <el-button slot="reference" v-if="!getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())"
          class="week-day-options el-icon-more" circle></el-button>
      </el-popover>
      <popup-discount-display :date="day" :small="true" />
      <div class="week-day-services-container"
        v-if="!getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())">
        <div
          :class="['week-day-services', { 'week-day-services-max': Object.entries(getMainServicesForDay(day, true, true)).length > 4 }]">
          <div class="week-day-service" v-for='(ms, msKey) in getMainServicesForDay(day, true, true)' :key="msKey">
            <div class="week-day-service-sub" v-for='(s, sKey) in ms' :key="sKey">
              <calendar-service :class="isLockedService(s.name)" :ms="s.name" :id="sKey" :length="ms.length" :date="day"
                :visibility="getToolTipVisibility"></calendar-service>
              <div v-if="cashState(s.name)">
                {{ getTypeCash(cashState(s.name).type) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="week-day-click" @click='clickDay()'></div>
      <div class="week-day-service-closed" v-if="getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())">
        Fermé
      </div>
    </div>
  </v-touch>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { dateToTimeStamp } from '../../tools/timeTool';
import PopupDiscountDisplay from '../popups/PopupDiscountDisplay';
import CalendarService from './CalendarService';

export default {
  name: 'CalendarDay',
  components: { CalendarService, PopupDiscountDisplay },
  data() {
    return {
      popover: false,
      occupationVisibility: false,
      switchers: {},
      radios: {}
    }
  },
  props: {
    day: {},
    tooltipVisibility: false
  },
  computed: {
    ...mapGetters({
      getMainServicesForDay: 'newServices/getMainServicesForDay',
      getMainServiceDataByServiceAndDay: 'newServices/getMainServiceDataByServiceAndDay',
      getDaysIsClosed: 'newServices/getDaysIsClosed',
      getDateToTimestamp: 'calendar/getDateToTimestamp',
      getAllServices: 'newServices/getAllServices',
      getServiceLockState: 'newServices/getServiceLockState',
      getCashDaysList: 'cash/getCashDaysList',
      getCountNewStateByDay: 'newReservations/getCountNewStateByDay'
    }),
    getToolTipVisibility: function () {
      if (this.occupationVisibility || this.tooltipVisibility) return true
      return false
    }
  },
  methods: {
    ...mapActions({
      setSelectedDayTo: 'calendar/setSelectedDayTo',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar',
      createLockedServices: 'newServices/createLockedServices',
      deleteLockedDays: 'newServices/deleteLockedDays',
      hideAll: 'displayer/hideAll'
    }),
    ...mapMutations({
      setSelectedRoom: 'newRooms/setSelectedRoom',
      setDialogEditCash: 'displayer/setDialogEditCash',
      setCashEditEntry: 'cash/setCashEditEntry'
    }),
    getTypeCash: function (type) {
      if (type === 'caution') return 'C'
      else return 'P'
    },
    showOccupation: function () {
      this.occupationVisibility = true
    },
    hideOccupation: function () {
      this.occupationVisibility = false
    },
    cashState: function (service) {
      let ts = dateToTimeStamp(this.day.date.getDate(), this.day.date.getMonth(), this.day.date.getFullYear())
      let cashList = this.getCashDaysList
      // get current service
      let serviceForDay = null
      if (this.getAllServices[service]) serviceForDay = this.getAllServices[service][this.day.labelDay]

      if (service && cashList && cashList[ts] && cashList[ts][service]) return cashList[ts][service]
      else if (serviceForDay && serviceForDay.cashOn) {
        return {
          type: serviceForDay.cashType,
          value: serviceForDay.cashPrice,
          isOnService: true
        }
      } else return ''
    },
    updateSwitchers: function () {
      let mainServicesCopy = Object.assign({}, this.getMainServicesForDay(this.day, true, true))
      let tmpSwitchers = {}
      Object.entries(mainServicesCopy).forEach(([msId, ms]) => {
        ms.forEach((s) => {
          tmpSwitchers[s.name] = !this.getServiceLockState(s.name, this.day)
        })
      })
      this.switchers = Object.assign({}, tmpSwitchers)
    },
    selectSwitcherChange: function (service) {
      // get switcher value
      let createLockedDay = !this.switchers[service.name]
      let ts = dateToTimeStamp(this.day.date.getDate(), this.day.date.getMonth(), this.day.date.getFullYear())
      // if create add locked day and service to db
      if (createLockedDay) {
        this.createLockedServices({
          days: [ts],
          service: service.name
        }).then(() => { }).catch((err) => {
          console.error(err)
        })
      } else { // else delete it
        this.deleteLockedDays({
          tIds: [ts],
          service: service.name
        }).then(() => { }).catch((err) => {
          console.error(err)
        })
      }
    },
    updateRadios: function () {
      let mainServicesCopy = Object.assign({}, this.getMainServicesForDay(this.day, true, true))
      let tmpRadios = {}
      Object.entries(mainServicesCopy).forEach(([msId, ms]) => {
        ms.forEach((s) => {
          tmpRadios[s.name] = 0
        })
      })
      this.radios = Object.assign({}, tmpRadios)
    },
    selectRadioChange: function (service) {
      // TODO: make action on radio change
    },
    isLockedService: function (serviceName) {
      if (this.switchers[serviceName]) return ''
      else return 'lock'
    },
    clickDay: function () {
      if (this.getDaysIsClosed(this.day.weekday, false, new Date(this.day.date).getTime()) === undefined) {
        this.setSelectedDayTo(this.day)
        this.showVisibilityCalendar(false)
        this.setSelectedRoom('')
        this.hideAll(true)
      }
    },
    editCashInfos: function (date, service) {
      let ts = dateToTimeStamp(date.day, date.month - 1, date.year)
      this.setCashEditEntry({
        days: [ts],
        service: service
      })
      this.setDialogEditCash(true)
    }
  },
  watch: {
    'day': function (val, oldVal) {
      this.updateSwitchers()
      this.updateRadios()
    },
    'getAllServices': function (val, oldVal) {
      this.updateSwitchers()
      this.updateRadios()
    }
  },
  mounted: function () {
    this.updateSwitchers()
    this.updateRadios()
  }
}
</script>

<style lang="scss">
.calendar-day-discount-button {
  position: absolute;
  top: 0;
  right: 30px;
  background-color: var(--color_red);
  color: white;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
}
</style>
